import React, { useMemo, useState } from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { accountsAPI } from 'api/accounting/accountsAPI';
import { FormikHelpers } from 'formik';
import { Button, Message } from '@ui';

// components
import { default as TemplateUpdateNicknameModalDialog } from 'components/ModalDialogs/TemplateModalDialogs/Accounts/UpdateNicknameModalDialog';

interface IProps {
  accountNumber?: string;
  accountNickname?: string;
  updateTrigger: () => void;
}

export type FormValuesModel = {
  accountNickname: string;
};

const UpdateNicknameModalDialog = ({
  accountNumber,
  accountNickname,
  updateTrigger,
}: IProps) => {
  const { t } = useTranslation('accounts');
  const [isVisible, setIsVisible] = useState(false);

  const initialFormValues = useMemo<FormValuesModel>(() => {
    return {
      accountNickname: accountNickname || '',
    };
  }, [accountNickname]);

  const onSubmit = async (
    values: FormValuesModel,
    _: FormikHelpers<FormValuesModel>,
  ) => {
    if (accountNumber) {
      await accountsAPI.updateAccountNickname(values, accountNumber);
      Message.success('You have successfully updated nickname of the account');
      updateTrigger();
    }
  };

  return (
    <div>
      <Button onClick={() => setIsVisible(true)}>
        {t('edit_button', { ns: 'common' })}
      </Button>
      <TemplateUpdateNicknameModalDialog
        title={t(
          'account_activity.account_details.update_nickname_modal.title',
        )}
        isVisible={isVisible}
        initialValues={initialFormValues}
        onSubmit={onSubmit}
        closeCallback={() => setIsVisible(false)}
      />
    </div>
  );
};

export default UpdateNicknameModalDialog;
